import React from 'react';
import { connect } from 'react-redux';
import {Helmet} from 'react-helmet';
import  PageHeader  from './PageHeader';
import  ResetPwForm   from './ResetPwForm';
import Footer from "../components/common/Footer";
import { startResetPw } from '../actions/auth'; 
// import { GoogleAdInit } from './advertisement/GoogleAdInit';
import  getAppConfigParm  from '../config/AppConfig';
import  VisibilityWrapper      from "../components/common/VisibilityWrapper";
import { displayAd } from './advertisements/helpers/displayAd';

// This ResetPwPage is the parent. It renders this page and the child component, ResetPwForm.
// This component passes its onSubmit method down to the ResetPwForm child component.
// It delegates the data entry and form data validation to the form itself. Once the
// form has validated the data, it will pass the form data up to this component by calling
// the onSubmit method passed down as a function prop. In addition to the form data, it will pass along the
// user's id and token that was part of the url on the email that was sent to user to reset password.
// That url is what was used to call the route associated with ResetPwPage.
// That form data will be used to dispatch
// the startResetPw action. The startResetPw action will validate 1x token. If valid, user's
// password will be reset and user will be routed to dashboard, with user firstname, email, 
// token, and isAuthenticated flag set. When action successfully completes, 
// the user will be routed to the '/dashboard'. If login fails, the auth.error property 
// will be updated on the redux store and component will re-render with error message on top of 
// form.
export class ResetPwPage extends React.Component { 

    // Dispatch action that resets user password. If id is not
    // registered, the auth.error property will be set on the redux store. If action is
    // successful, it will route user to dashboard, and the 1x token on the email will no longer
    // be valid because it should have been overriden when new password was saved.
    onSubmit = (resetPwData = {}) => {
        this.props.startResetPw(resetPwData);
    };
     
    // Render ResetPwPage and pass onSubmit function above, as function prop, to RestPassPwForm. This 
    // function prop wll be called when user enters enters new and confirmed pasword. Since this page
    // will be rendered via the link found in users email, it will also pass down the user id and 1x
    // token to the form.
    render() {

        /* Get the showAd directive from the AppConfig */
        let showAd = getAppConfigParm("showAd");

        return (
            <div> 
               <Helmet>
                    <title>Reset Password Pitch In Club</title>
                    <meta name="description" content="Reset Password Pitch In Club" />
               </Helmet>
               <PageHeader />
               <VisibilityWrapper show={showAd} contentType="advertisement">
               <div className="rc-flex-container-center-hv"  style={{borderTop: '1px solid #95A5A6'}}>
                   {displayAd("web-leader-board", "desktop", {marginLeft: '0rem', marginTop: '1.3rem', marginBottom: '1.3rem'})}
                   {displayAd("", "mobile", {marginTop: '1rem', marginBottom: '1rem'})}
                   {displayAd("web-leader-board", "tablet", {marginTop: '1.3rem', marginBottom: '1.3rem'})}
               </div>
               </VisibilityWrapper>  
               <div className="app-container">    
                    <div className="app-container-alt3">        
                        <div className="app-content-container"> 
                            <div>
                                <ResetPwForm 
                                onSubmit={this.onSubmit}
                                id={this.props.match.params.id}
                                token={this.props.match.params.token}
                                />  
                            </div>
                        </div>
                    </div>
               </div>
               <VisibilityWrapper show={showAd} contentType="advertisement" >
                <div className="rc-flex-container-center-hv" style={{borderTop: '1px solid #BDC3C7'}}> 
                    {displayAd("web-leader-board", "desktop", {marginLeft: '0rem', marginTop: '1.3rem', marginBottom: '1.3rem'})}
                    {displayAd("", "mobile", {marginTop: '1rem', marginBottom: '1rem'})}
                    {displayAd("web-leader-board", "tablet", {marginTop: '1.5rem', marginBottom: '1.3rem'})}
                </div> 
               </VisibilityWrapper>
               <Footer />
            </div>
        );
    };
};


// When using mapDispatchToProps you invoke function in your component as follows:
// this.props.startSignup(signupData) and not like this: this.props.dispatch(startSignup(signupData))
const mapDispatchToProps = (dispatch) => ({
    startResetPw: (resetPwData) => dispatch(startResetPw(resetPwData)),
})

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPwPage);





// WEBPACK FOOTER //
// ./src/components/ResetPwPage.js